const checkNullableValue = v => v !== null && v !== undefined;

export default checkNullableValue;
